module.exports = __webpack_public_path__ + "media/images/pc/page_common/purpose_commitment-3c98d4213230a63adaf5671cc646f44e.png";